import React, { useEffect, useState } from 'react';
import { isMobileViewport, useScreenBreakpoint } from './screen';

function useCheckMobile() {
  const [isMobile, setIsMob] = useState(false);
  const breakpoint = useScreenBreakpoint();

  useEffect(() => {
    setIsMob(isMobileViewport());
  }, [breakpoint]);

  return isMobile;
}

export default useCheckMobile;
